export default {"src":"/_next/static/media/positionOpposition.7ece51d8.svg","height":400,"width":409,"blurWidth":0,"blurHeight":0};